import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Facebook, Youtube } from "lucide-react";
import { useCookieConsent } from "../providers/CookieConsentProvider";

const Footer = () => {
  const { openSettings } = useCookieConsent();
  return (
    <footer className="bg-slate-900 text-slate-200">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/513e8760-b016-4254-a9f0-0e6363e59ce4.png" 
                alt="Niumora Logo" 
                width={120}
                height={40}
                className="h-10 w-auto" 
              />
            </Link>
            <p className="text-slate-300 max-w-xs">
              Transforming businesses through AI-powered solutions and training.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/people/Niumora/61574181287893/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-slate-500"
              >
                <span className="sr-only">Facebook</span>
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://www.tiktok.com/@niumora_ai?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-slate-500"
              >
                <span className="sr-only">TikTok</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@niumora-uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-slate-500"
              >
                <span className="sr-only">YouTube</span>
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#services" className="text-slate-300 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/ai-bootcamp" className="text-slate-300 hover:text-white transition-colors">
                  AI Bootcamp
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-slate-300 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-slate-300 hover:text-white transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-300 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="flex items-start gap-3">
              <Mail className="h-5 w-5 text-primary mt-0.5" />
              <a href="mailto:hey@niumora.com" className="text-slate-300 hover:text-white transition-colors">
                hey@niumora.com
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-center items-center gap-4">
          <div className="text-slate-400 text-sm text-center">
            &copy; {new Date().getFullYear()} niumora. All rights reserved.{" "}
            |{" "}
            <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition-colors">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-use" className="text-slate-400 hover:text-white transition-colors">
              Terms of Use
            </Link>{" "}
            |{" "}
            <button
              onClick={openSettings}
              className="text-slate-400 hover:text-white transition-colors inline p-0 align-baseline"
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
